/**
 * Visionneuse plein écran de la fiche produit.
 * Ouverture au clic sur une photo, navigation clavier, zoom au clic.
 * S'appuie sur <dialog> natif : la gestion du focus et de la touche Échap
 * est assurée par le navigateur.
 */
(() => {
  const dialog = document.querySelector('[data-vsh-lightbox]');
  const gallery = document.querySelector('[data-vsh-gallery]');
  if (!dialog || !gallery) return;

  const img = dialog.querySelector('[data-vsh-lightbox-img]');
  const counter = dialog.querySelector('[data-vsh-lightbox-counter]');
  const shots = Array.from(gallery.querySelectorAll('[data-vsh-zoom]'));
  if (!shots.length) return;

  let index = 0;

  const show = (i) => {
    index = (i + shots.length) % shots.length;
    const source = shots[index].querySelector('img');
    img.src = source.dataset.full || source.currentSrc || source.src;
    img.alt = source.alt || '';
    img.dataset.zoomed = 'false';
    if (counter) counter.textContent = `${index + 1} / ${shots.length}`;
  };

  shots.forEach((btn, i) =>
    btn.addEventListener('click', () => {
      show(i);
      if (!dialog.open) dialog.showModal();
    })
  );

  dialog.querySelector('[data-vsh-lightbox-close]')?.addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-vsh-lightbox-prev]')?.addEventListener('click', () => show(index - 1));
  dialog.querySelector('[data-vsh-lightbox-next]')?.addEventListener('click', () => show(index + 1));

  img.addEventListener('click', () => {
    img.dataset.zoomed = img.dataset.zoomed === 'true' ? 'false' : 'true';
  });

  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
  });

  // Clic sur le fond (hors image et hors contrôles) = fermeture
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.classList.contains('vsh-lightbox__stage')) dialog.close();
  });
})();

/**
 * Planificateur de livraison — jalons de l'acheminement.
 *
 * Annonce la fenêtre d'arrivée, puis déroule le trajet en trois jalons.
 * Tout est calculé en JOURS OUVRÉS (samedi et dimanche sautés) à partir d'un
 * délai de préparation et d'un délai d'acheminement propre à chaque zone.
 *
 * C'est une estimation, pas un engagement transporteur : aucun appel n'est
 * fait à un transporteur et rien n'est transmis au panier.
 */
(() => {
  const root = document.querySelector('[data-vsh-plan]');
  if (!root) return;

  const stepsEl = root.querySelector('[data-vsh-plan-steps]');
  const leadEl = root.querySelector('[data-vsh-plan-window]');
  const noteEl = root.querySelector('[data-vsh-plan-note]');
  const zones = Array.from(root.querySelectorAll('[data-zone]'));

  const num = (k, d) => parseInt(root.dataset[k], 10) || d;
  const transit = { fr: num('fr', 2), eu: num('eu', 4), intl: num('intl', 8) };
  const dispatch = num('dispatch', 3);

  const DAY_MONTH = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
  const WEEK_DAY_MONTH = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  /** Avance de n jours ouvrés (samedi et dimanche ignorés). */
  const addOpenDays = (from, n) => {
    const d = new Date(from.getTime());
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) left--;
    }
    return d;
  };

  const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

  /** « 24 – 26 août » plutôt que « 24 août – 26 août » quand le mois est le même. */
  const range = (a, b) => {
    if (sameDay(a, b)) return DAY_MONTH.format(a);
    if (a.getMonth() === b.getMonth()) return `${a.getDate()} – ${DAY_MONTH.format(b)}`;
    return `${DAY_MONTH.format(a)} – ${DAY_MONTH.format(b)}`;
  };

  let zone = 'fr';

  const render = () => {
    const today = new Date();
    const shipFrom = addOpenDays(today, Math.max(dispatch - 1, 1));
    const shipTo = addOpenDays(today, dispatch);
    const arriveFrom = addOpenDays(shipTo, transit[zone]);
    const arriveTo = addOpenDays(arriveFrom, 2);

    leadEl.textContent = range(arriveFrom, arriveTo);
    leadEl.setAttribute(
      'aria-label',
      `Livraison estimée entre le ${WEEK_DAY_MONTH.format(arriveFrom)} et le ${WEEK_DAY_MONTH.format(arriveTo)}`
    );

    const steps = [
      { date: DAY_MONTH.format(today), title: 'Commande confirmée', done: true },
      { date: range(shipFrom, shipTo), title: "Départ de l'atelier", done: false },
      { date: range(arriveFrom, arriveTo), title: 'Livraison chez vous', done: false },
    ];

    stepsEl.textContent = '';
    steps.forEach((s, i) => {
      const li = document.createElement('li');
      li.className = 'vsh-plan__step';
      li.dataset.done = String(s.done);
      li.style.setProperty('--i', String(i));
      li.innerHTML =
        '<span class="vsh-plan__mark" aria-hidden="true"></span>' +
        `<span class="vsh-plan__date"></span>` +
        `<span class="vsh-plan__title"></span>`;
      li.querySelector('.vsh-plan__date').textContent = s.date;
      li.querySelector('.vsh-plan__title').textContent = s.title;
      stepsEl.appendChild(li);
    });

    noteEl.textContent =
      `Expédition sous ${dispatch} jours ouvrés depuis la France, en envoi suivi et assuré. ` +
      'Estimation indicative, hors douane et jours fériés.';
  };

  zones.forEach((btn) =>
    btn.addEventListener('click', () => {
      zone = btn.dataset.zone;
      zones.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      render();
    })
  );

  render();
})();
